import React, { useEffect, useState } from 'react';
import { Input, message, Modal } from 'antd';
import { fetcher } from '../../../extras/fetcher';

interface Props {
  open: boolean;
  onClose: () => void;
  onAdded: () => void;
}

const courierTripPattern = /^(?:[6-9][0-9]{5}|1[0-9]{6})$/;

export const ModalAddAutomationTrip = ({open, onClose, onAdded}: Props) => {
  const [trip, setTrip] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (open) {
      setTrip('');
    }
  }, [open]);

  const handleOk = async () => {
    if (!courierTripPattern.test(trip)) {
      messageApi.error(
        'Trip musi mieć 6 cyfr i zaczynać się od 6-9 albo mieć 7 cyfr i zaczynać się od 1.',
      );
      return;
    }

    setLoading(true);
    const response = await fetcher('courier/automation', 'POST', {trip});
    setLoading(false);

    if (response.status === 403) {
      messageApi.error('Nie posiadasz wymaganych uprawnień!');
      return;
    }

    if (response.status >= 400) {
      const responseMessage = Array.isArray(response.result?.message)
        ? response.result.message.join(' ')
        : response.result?.message || response.result?.error;
      messageApi.error(responseMessage || 'Nie udało się dodać tripa.');
      return;
    }

    messageApi.success(`Trip ${trip} został dodany do automatyzacji.`);
    onClose();
    onAdded();
  };

  return <>
    <Modal
      title="Dodawanie tripa do automatyzacji"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={loading}
      okText="Dodaj"
      cancelText="Anuluj"
    >
      <div style={{display: 'flex', flexDirection: 'column', gap: 10, paddingTop: 10}}>
        <label htmlFor="courier-automation-trip">Trip</label>
        <Input
          id="courier-automation-trip"
          value={trip}
          maxLength={7}
          inputMode="numeric"
          placeholder="Numer tripa"
          onChange={(event) => setTrip(event.target.value.replace(/\D/g, ''))}
          onPressEnter={handleOk}
        />
      </div>
    </Modal>
    {contextHolder}
  </>;
};

